// La imagen que ocupa el hueco cuando no hay foto del artista, carátula del
// disco o imagen del programa.
//
// 🔴 **Es la A oblicua de la marca, una por tema** —decisión de Pablo del
// 28.09.26—: la de `AstraMark fondo="ninguno"` con su degradado, centrada al
// 30 % del ancho sobre `color/art/mid`. Sustituye a `astra-placeholder.png`,
// la A turquesa de la identidad anterior, que pesaba 2,7 MB.
//
// ── Por qué dos ficheros y no uno ──
//
// Un SVG cargado como imagen no ve el `data-theme` de la página: no hay forma
// de que cambie solo. Así que hay uno por tema y quien pinta pide el que toca
// con `arte()`. Los datos llevan siempre `PLACEHOLDER` —el oscuro— y la
// traducción se hace al pintar, que es lo único que responde al cambio de tema.
//
// ── Y por qué no pasa por el gris ──
//
// Las imágenes del sistema van en gris hasta que suenan. La A no es una imagen
// que vuelva a color: es la marca, y en gris dejaría de serlo. Quien pinta
// mira `esPlaceholder()` y le quita el filtro.
import { ref } from "vue";
import oscuro from "@/assets/marca/placeholder-oscuro.svg";
import claro from "@/assets/marca/placeholder-claro.svg";

/** El valor que viaja en los datos cuando no hay imagen. */
export const PLACEHOLDER = oscuro;

const leerTema = () =>
  typeof document !== "undefined" &&
  document.documentElement.getAttribute("data-theme") === "light"
    ? "light"
    : "dark";

const tema = ref(leerTema());

// El tema lo cambia `useTheme` escribiendo el atributo en `<html>`; se escucha
// ahí para no depender de quién lo cambie.
if (typeof MutationObserver !== "undefined" && typeof document !== "undefined") {
  new MutationObserver(() => {
    tema.value = leerTema();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme"],
  });
}

/** ¿Es esta URL el placeholder, de cualquiera de los dos temas? */
export function esPlaceholder(src) {
  return src === oscuro || src === claro;
}

/**
 * La URL que hay que pintar: la misma si es una imagen de verdad, y el
 * placeholder del tema activo si es el placeholder. Reactiva: llamada desde una
 * plantilla o un `computed`, cambia al cambiar el tema.
 */
export function arte(src) {
  if (!esPlaceholder(src)) return src;
  return tema.value === "light" ? claro : oscuro;
}
